module.exports = __webpack_public_path__ + "fab781e16145bd06a9137a1dcbc8befc.svg";